// import Vue from 'vue'
// import Vuex from 'vuex'

import { createStore } from 'vuex'
import view from '@/store/modules/view'
import { navigation } from '@/store/modules/navigation'

import { traffic } from '@/store/modules/widgets-others/traffic'
import { deviceDistribution } from '@/store/modules/widgets-others/deviceDistribution'
import { similarSites } from '@/store/modules/widgets-others/similarSites'
import { subDomains } from '@/store/modules/widgets-others/subDomains'

import { mainData } from '@/store/modules/widgets-main-data/mainData'
import { marketingChannels } from '@/store/modules/widgets-main-data/marketingChannels'
import { geo } from '@/store/modules/widgets-main-data/geo'

import { authModule } from './modules/auth'
import { userInfo } from './modules/user-info'
import { notifications } from './modules/notifications'
import { addDomainModal } from './modules/addDomainModal'
import { limits } from './modules/limits'

// Vue.use(Vuex)

const store = createStore({
  strict: process.env.NODE_ENV !== 'production',
  actions: {},
  state: {},
  mutations: {},
  getters: {},

  modules: {
    view,
    mainData,
    traffic,
    marketingChannels,
    similarSites,
    subDomains,
    deviceDistribution,
    geo,
    authModule,
    userInfo,
    navigation,
    addDomainModal,
    notifications,
    limits,
  },
})

window._vueXStore = store

export default store
